import React from "react";

export default function SQL_Create_DB() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Create_DB</h1>
      <p>This is the SQL_Create_DB component generated from the SQL JSON.</p>
    </div>
  );
}
